var exports = {
  "x": "x936d19a0--f93d9a--button",
};

module.exports = exports;
